"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Ctopage_1 = require("./Ctopage");
exports.default = Ctopage_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ctopage/index.js
// module id = 1134
// module chunks = 8